var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 41,
    viewBox: "0 0 73 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 73,
    height: 41,
    rx: 5,
    fill: "#D9D9D9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1714_2442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.479 17.2311C37.4465 19.7286 39.7641 21.1221 41.51 21.9508C43.3037 22.8009 43.9062 23.3461 43.8991 24.1065C43.8857 25.27 42.4683 25.7835 41.1419 25.8034C38.8279 25.8384 37.4824 25.1949 36.4127 24.7083L35.5791 28.5076C36.6523 28.9892 38.6395 29.4093 40.7002 29.4277C45.5374 29.4277 48.702 27.102 48.7192 23.4962C48.7381 18.9199 42.2203 18.6666 42.2648 16.6211C42.2802 16.0008 42.8878 15.3389 44.2193 15.1707C44.8783 15.0856 46.6977 15.0206 48.7603 15.9457L49.5699 12.2698C48.4606 11.8764 47.035 11.4997 45.26 11.4997C40.7071 11.4997 37.5048 13.8571 37.479 17.2311ZM57.3491 11.8164C56.4658 11.8164 55.7215 12.3182 55.3893 13.0883L48.4796 29.1577H53.3132L54.2751 26.5686H60.1817L60.7397 29.1577H65L61.2823 11.8164H57.3491ZM58.0253 16.5009L59.4202 23.0128H55.5999L58.0253 16.5009ZM31.6185 11.8166L27.8084 29.1575H32.4145L36.2228 11.8161L31.6185 11.8166ZM24.8045 11.8166L20.0103 23.6196L18.071 13.5836C17.8434 12.4633 16.9448 11.8164 15.9468 11.8164H8.10977L8 12.3199C9.60891 12.66 11.4369 13.2084 12.5444 13.7953C13.2222 14.1538 13.4154 14.4671 13.6381 15.319L17.3113 29.1577H22.1788L29.6413 11.8164L24.8045 11.8166Z",
    fill: "url(#paint0_linear_1714_2442)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1714_2442",
    x1: 2628.52,
    y1: 65.3913,
    x2: 2679.06,
    y2: -1775.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#254AA5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1714_2442"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 18,
    fill: "white",
    transform: "translate(8 11.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.1c015d600e2da78ea8fe299f83543fd6.svg";
export { ForwardRef as ReactComponent };